export default {
  centered: "flex items-center w-full gap-2 text-text justify-center lg:justify-start",
  left: "flex gap-2 text-text justify-start",
}